export default __webpack_public_path__ + "static/media/q24_v2.c7f3eaf2.png";